// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { alertSettingsActions, globalActions } from "src/actions";

import { IProps, TabId } from "@blueprintjs/core";

import { ListHeader, StyledButton, ToggleButtons } from 'src/components';

import { Redirect, Route, Switch } from "react-router-dom";

import GroupsSettingsAdd from './group-settings-add';

import { SettingsGroupsMemberListItem, SettingsTabs } from '../components';

import { MPDIcon } from "src/mpd-library";

import "./styles.css";

interface IGroupsSettingsEditProps extends IProps {
  itemType: string;
  routeProps: any;
  manage?: any;
  onInviteMembers: (
    group: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onUpdateToolBar: (
    topBarProps: any
  ) => (dispatch: Dispatch<any>) => Promise<void>;
  onCloseRightPanel?(): void;
  onToggleRightPanel?(): void;
}

interface IGroupsSettingsEditState {
  selectedTabNum: TabId;
  tabs: Array<string>;
  groupId?: any;
  groupToEdit?: any;
}

class GroupsSettingsEdit extends React.Component<IGroupsSettingsEditProps, IGroupsSettingsEditState> {
  constructor(props: IGroupsSettingsEditProps) {
    super(props);
    this.initialize = this.initialize.bind(this);
    this.onInviteMembers = this.onInviteMembers.bind(this);
    this.updatedselectedTabNum = this.updatedselectedTabNum.bind(this);
    this.onChangeTab = this.onChangeTab.bind(this);
    this.state = {
        selectedTabNum: 0,
        tabs: ['members', 'settings'],
        groupToEdit: null,
        groupId: null
    }
  }

  public componentDidMount() {
      this.initialize(this.props);
  }

  public componentWillReceiveProps(nextProps: IGroupsSettingsEditProps) {
    const { groupToEdit, groupId } = this.state;
    const { itemType, manage, routeProps } = this.props;
    if(nextProps.routeProps !== this.props.routeProps) {
      const pathname = routeProps.history.location.pathname;
      this.updatedselectedTabNum();
      if(pathname.includes('members')){
        const text = itemType + ' / ' + groupToEdit.id;
        this.updateToMemberToolBar(text);
      }
    }
    if(nextProps.manage !== this.props.manage) {
      const newGroupToEdit = alertSettingsActions.onGetItem(itemType, groupId, manage);
      this.setState({groupToEdit: newGroupToEdit})
    } 
  }

  public render() {
    const { className, routeProps, itemType } = this.props;
    const { groupToEdit, tabs, selectedTabNum } = this.state;
    return (
        <div className={classNames('group-settings-edit-container', className)}>
            <Switch>
                <Redirect exact={true} from={`/alerts-settings/groups/edit/${groupToEdit && groupToEdit.id}`} to={`/alerts-settings/groups/edit/${groupToEdit && groupToEdit.id}/members`} />
                <Route
                    exact={true}
                    path={`/alerts-settings/groups/edit/${groupToEdit && groupToEdit.id}/members`}
                    render={() => (
                    <React.Fragment>
                        <SettingsTabs
                            className='group-settings-edit-tabs'
                            tabs={tabs}
                            tabsProps={{
                                id: 'social-settings-tabs',
                                onChange: this.onChangeTab,
                                selectedTabId: selectedTabNum
                            }}
                        />
                        {groupToEdit.members && groupToEdit.members.length > 0 ?
                          <React.Fragment>
                            <ListHeader className='group-settings-edit-list-header' />
                            <div className='group-settings-edit-list'>
                              {groupToEdit.members.map((member: any, index: number) => (
                                <SettingsGroupsMemberListItem 
                                  active={member.active}
                                  key={index}
                                  initials={member.initials}
                                  title={member.title}
                                  status={member.active ? 'Member Since ' + member.date : 'Deactive'}
                                  statusOptions={['edit', 'delete', 'deactivate']}
                                />
                              ))}
                            </div>
                          </React.Fragment>
                          :
                          
                         <div className='group-settings-edit-empty-container'>
                            <MPDIcon name='compose-alert--audience--groups-active' />
                            <div className='group-settings-edit-empty-title'> No Members Found </div>
                            <div className='group-settings-edit-empty-subtitle'> It looks like no one has signed up for your group yet. </div>
                         </div>
                        }
                    </React.Fragment>
                    )}
                />
                <Route
                    exact={true}
                    path={`/alerts-settings/groups/edit/${groupToEdit && groupToEdit.id}/settings`}
                    render={() => (
                      <React.Fragment>
                        <SettingsTabs
                            className='group-settings-edit-tabs'
                            tabs={tabs}
                            tabsProps={{
                                id: 'social-settings-tabs',
                                onChange: this.onChangeTab,
                                selectedTabId: selectedTabNum
                            }}
                        />
                        <GroupsSettingsAdd 
                          groupToEdit={groupToEdit}
                          groupId={groupToEdit.id}
                          routeProps={routeProps}
                          itemType={itemType}
                          onCloseRightPanel={this.props.onCloseRightPanel}
                          onToggleRightPanel={this.props.onToggleRightPanel}
                        />
                      </React.Fragment>
                    )}
                />
            </Switch>
        </div>
    );
  }

  private updatedselectedTabNum() {
    const { routeProps, } = this.props;
    const { tabs } = this.state;
    const pathname = routeProps.history.location.pathname;
    const pathArr = pathname.split('/');
    const selectedTabNum = tabs.findIndex((tab:any) => tab === pathArr[pathArr.length - 1]);
    this.setState({ selectedTabNum });
  }

  private onChangeTab(newTabNum: TabId, prevTabNum: TabId, event: any) {
    const { routeProps, itemType } = this.props;
    const { tabs, groupToEdit } = this.state;
    const tabId = tabs[newTabNum].toLowerCase();
    this.setState({ selectedTabNum: newTabNum })
    const text = itemType + ' / ' + groupToEdit.id;

    if(tabId === 'members'){
      this.updateToMemberToolBar(text);
    }

    routeProps.history.push(`/alerts-settings/groups/edit/${groupToEdit && groupToEdit.id}/${tabId}`);
  }

  private onInviteMembers() {
    let { groupToEdit } = this.state;
    groupToEdit = this.props.onInviteMembers(groupToEdit);
    this.setState({ groupToEdit });
  }

  private initialize(props: any) {
    const { itemType, manage, routeProps } = props;
    const pathname = this.props.routeProps.history.location.pathname;
    const pathArr = pathname.split('/');
    const groupId = pathArr[pathArr.length -1];
    const groupToEdit = alertSettingsActions.onGetItem(itemType, groupId, manage);
    if(groupToEdit === null){
        routeProps.history.push('/alerts-settings/' + itemType);
    }
    else {
        this.setState({ groupToEdit, groupId }); 
    }
  }

  private updateToMemberToolBar(text: string) {
    const topBarProps = {
      leftElement: (
        <ToggleButtons
          label={text.charAt(0).toUpperCase() + text.slice(1)}
          onToggle={this.props.onToggleRightPanel}
          onClose={this.props.onCloseRightPanel}
        />
      ),
      rightElement: (
        <StyledButton
          type='default-blue'
          onClick={this.onInviteMembers}
          text='Invite Members'
        />
      )
    };
    if(this.props.onUpdateToolBar){
      this.props.onUpdateToolBar(topBarProps);
    }
  }
}

const mapStateToProps = (state: any) => {
  const {  alertSettings } = state;
  const { manage } = alertSettings;
  return {
    manage
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    onUpdateToolBar: bindActionCreators(
      globalActions.onUpdateToolBar,
      dispatch
    ),
    onCancelChanges: bindActionCreators(
      alertSettingsActions.onCancelChanges,
      dispatch
    ),
    onSaveChanges: bindActionCreators(
      alertSettingsActions.onSaveChanges,
      dispatch
    ),
    onInviteMembers: bindActionCreators(
      alertSettingsActions.onInviteGroupMemembers,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupsSettingsEdit);



// WEBPACK FOOTER //
// ./src/controllers/alert-settings/groups-settings/group-settings-edit.tsx